import { useSelector } from "react-redux";

import { useSharesActions } from "store/SharesSlice";

const useShares = () => {
  const { createShare, setDateToShare, resetDateToShare } = useSharesActions();

  const { dateToShare } = useSelector((state) => state.SharesSlice);

  return { createShare, setDateToShare, dateToShare, resetDateToShare };
};

export default useShares;
